import React from 'react';
import Toggle from '../SideDrawer/Toggle';
import {NavLink} from 'react-router-dom'
import { useLocale } from '../../localization/LocaleContext';
import NavDropdown from './NavDropdown';
import './toolbar.css';

const Toolbar = props => {
    const { t, toLocalizedPath } = useLocale();

    const featureItems = [
        { to: toLocalizedPath('aiEstimator'), label: t('nav.aiEstimator') },
        { to: toLocalizedPath('invoicing'), label: t('nav.invoicing') },
        { to: toLocalizedPath('quotes'), label: t('nav.quotes') },
        { to: toLocalizedPath('timeTracking'), label: t('nav.timeTracking.heading') },
        { to: toLocalizedPath('payments'), label: t('nav.payments') },
        { to: toLocalizedPath('paymentReminders'), label: t('nav.paymentReminders') },
        { to: toLocalizedPath('clients'), label: t('nav.clients') },
        { to: toLocalizedPath('expenses'), label: t('nav.expenses') },
        { to: toLocalizedPath('reports'), label: t('nav.reports') }
    ];

    const solutionItems = [
        { to: toLocalizedPath('freelancers'), label: t('nav.freelancers') },
        { to: toLocalizedPath('smallBusiness'), label: t('nav.smallBusiness') },
        { to: toLocalizedPath('organization'), label: t('nav.organization') }
    ];

    const resourceItems = [
        { to: toLocalizedPath('howItWorks'), label: t('nav.howItWorks') },
        { to: toLocalizedPath('helpCenter'), label: t('nav.helpCenter') },
        { to: toLocalizedPath('templates'), label: t('nav.templates') },
        { to: toLocalizedPath('guides'), label: t('nav.guides') },
        { to: toLocalizedPath('blog'), label: t('nav.blog') },
        { to: toLocalizedPath('contact'), label: t('nav.contact') }
    ];

    return (
        <header className="toolbar">
            <nav className="toolbar-navigation">
                <NavLink exact={true} to={toLocalizedPath('home')}>
                    <div className="toolbar-logo">
                        <img src={`${process.env.PUBLIC_URL}/images/main-logo.svg`} alt="Invoice Point logo" />
                    </div>
                </NavLink>
                <div className="spacer"></div>
                <Toggle click={props.drawerClickHandler} />
                <div className="toolbar-navigation-items">
                    <ul>
                        <li>
                            <NavLink exact={true} activeStyle={{borderBottom:"2px solid #fff"}} to={toLocalizedPath('home')}>
                                {t('nav.home')}
                            </NavLink>
                        </li>
                        <NavDropdown label={t('nav.features')} items={featureItems} />
                        <NavDropdown label={t('nav.solutions')} items={solutionItems} />
                        <li>
                            <NavLink activeStyle={{borderBottom:"2px solid #fff"}} to={toLocalizedPath('pricing')}>
                                {t('nav.pricing')}
                            </NavLink>
                        </li>
                        <NavDropdown label={t('nav.resources')} items={resourceItems} />
                    </ul>
                </div>
            </nav>
        </header>
    )
}

export default Toolbar;